import React, {Component} from 'react';
import {
  Button,
  Container,
  Form,
  Card,
  Row,
  Col,
  Modal,
  Image,
  Table,
} from 'react-bootstrap';
import '../Common/Common.css';
import ReactPaginate from 'react-paginate';
import SupportView from './SupportView';
import {DropdownButton, OverlayTrigger, Tooltip} from 'react-bootstrap';

var dateFormat = require('dateformat');

class Support extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showsptModal: false,
      showsupportviewModal: false,
      sptType: '',
      issueDesc: '',
      issueError: '',
      sptTypeError: '',

      page: 0,
      perPage: 10,

      sptFilter: '',
    };
  }

  componentDidMount() {
    this.props.getSupportTypes();
    this.props.getSupportTickets({
      page: undefined,
      filter: this.state.sptFilter,
    });
  }

  onValueChange = ev => {
    let {value, name} = ev.target;

    if (name === 'spttype') {
      this.setState({
        ...this.state,
        sptType: value,
        sptTypeError: '',
      });
    } else if (name === 'sptdesc') {
      this.setState({
        ...this.state,
        issueDesc: value,
        issueError: '',
      });
    }
  };

  showsupportModal = item => {
    this.setState({
      ...this.state,
      showsupportviewModal: true,
      supportDetail: item,
    });
  };

  closesupportviewModal = () => {
    this.setState({
      ...this.state,
      showsupportviewModal: false,
    });
  };

  showSupportModal = () => {
    this.setState({
      ...this.state,
      showsptModal: true,
      sptType: '',
      issueDesc: '',
      issueError: '',
      sptTypeError: '',
    });
  };

  handleClose = () => {
    this.setState({
      ...this.state,
      showsptModal: false,
    });
  };

  validateFields = () => {
    let isError = false;
    const {issueDesc, sptType} = this.state;

    const errmsg1 = 'Please select a support type!';
    const errmsg = 'Please enter your query!';

    const errors = {
      issueError: '',
      sptTypeError: '',
    };

    if (sptType === '') {
      isError = true;
      errors.sptTypeError = errmsg1;
    }
    if (issueDesc === '') {
      isError = true;
      errors.issueError = errmsg;
    }

    this.setState({
      ...this.state,
      ...errors,
    });

    return isError;
  };

  sendQuery = () => {
    const {sptType, issueDesc} = this.state;
    const validateError = this.validateFields();

    if (!validateError) {
      const data = {
        sptType: sptType,
        issueDesc: issueDesc,
      };
      this.props.sendSupportQuery(data);

      this.setState({
        showsptModal: false,
        sptType: '',
        issueDesc: '',
      });
    }
  };

  //For pagination
  handleSptPageClick = e => {
    const selectedSptPage = e.selected;
    this.props.SptpageSelected({
      page: selectedSptPage + 1,
      filter: this.state.sptFilter,
    });
    this.setState({page: selectedSptPage});
  };

  resetPage = () => {
    this.setState({page: 0});
  };

  //For Filter
  sptFilterChange = ev => {
    //this.resetPage();
    this.setState(
      {
        ...this.state,
        page: 0,
        sptFilter: ev.target.value,
      },
      () => {
        this.props.SptpageSelected({
          page: undefined,
          filter: this.state.sptFilter,
        });
      }
    ); //synchronous call
  };

  renderTooltip = props =>
    <Tooltip id="button-tooltip" {...props}>
      View
    </Tooltip>;

  render() {
    //Destructuring
    const {supportTypeList, supportTickets, supportTicketsCount} = this.props;
    const {
      showsptModal,
      showsupportviewModal,
      issueDesc,
      issueError,
      sptTypeError,
      page,
      perPage,
      sptFilter,
    } = this.state;
    const {
      showSupportModal,
      handleClose,
      onValueChange,
      sendQuery,
      handleSptPageClick,
      sptFilterChange,
      showsupportModal,
      closesupportviewModal,
    } = this;

    //For Pagination
    const Sptcount = supportTicketsCount;
    let p = page + 1;
    let SptPageCount = Math.ceil(Sptcount / perPage);

    return (
      <div className="salesreturndiv">
        <Modal
          className="sptModal"
          show={showsptModal}
          onHide={handleClose}
          backdrop="static"
          keyboard={false}
          centered={true}
        >
          <Modal.Header
            style={{
              fontSize: '35px',
              backgroundColor: '#1768B7',
              color: 'white',
            }}
            closeButton
          >
            <Modal.Title>
              <span style={{fontSize: '20px'}}>Raise Support Query</span>
            </Modal.Title>
          </Modal.Header>

          <Modal.Body>
            <Form>
              <Form.Group controlId="spttype">
                <Form.Label>Support Type</Form.Label>
                <Form.Control
                  as="select"
                  name="spttype"
                  onChange={onValueChange}
                >
                  <option value="">Select the support type...</option>
                  {supportTypeList &&
                    supportTypeList.map((item, i) =>
                      <option key={i} value={item.id}>
                        {item && item.supportType}
                      </option>
                    )}
                </Form.Control>
                <div className="errStyle">
                  {sptTypeError}
                </div>
              </Form.Group>
              <Form.Group controlId="sptdesc">
                <Form.Label>Description</Form.Label>
                <Form.Control
                  className="sptDesc"
                  as="textarea"
                  name="sptdesc"
                  value={issueDesc}
                  placeholder="Please elaborate your issue"
                  onChange={onValueChange}
                  rows={3}
                />
                <div className="errStyle">
                  {issueError}
                </div>
              </Form.Group>
            </Form>
          </Modal.Body>
          {/* <Modal.Footer>
            <Button className="queryBtn" onClick={handleClose}>
              Cancel
            </Button>
            <Button className="queryBtn" onClick={sendQuery}>
              Send
            </Button>
          </Modal.Footer> */}
          <Modal.Footer style={{backgroundColor: '#1768B7'}}>
            {/* <Button className="queryBtn" onClick={handleClose}>
              Cancel
            </Button> */}
            <Button className="queryBtnaccept" onClick={sendQuery}>
              Send
            </Button>
          </Modal.Footer>
        </Modal>

        {/* ======================card====================================== */}

        <Card>
          {/* <Card.Header className="commontableheader"> */}
          <div className="salesheader">
            <Row>
              <Col xs={12} sm={12} md={3} lg={3}>
                {/* <div className="commontableheadername"> */}
                {/* <Button className="queryBtn" onClick={showSupportModal}>
                    RAISE SUPPORT QUERY
                  </Button> */}
                <div>
                  <h5 className="tablecardtitle">Support Tickets</h5>
                </div>
                {/* </div> */}
              </Col>
              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="commonInputdiv">
                  <div className="commonInput">
                    <Button className="queryBtn" onClick={showSupportModal}>
                      RAISE SUPPORT QUERY
                    </Button>
                  </div>
                </div>
              </Col>
              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="">
                  <select
                    value={sptFilter}
                    onChange={sptFilterChange}
                    className="commonFilterSelect"
                  >
                    <option value="">All</option>
                    {supportTypeList &&
                      supportTypeList.map((item, i) =>
                        <option key={i} value={item.id}>
                          {item && item.supportType}
                        </option>
                      )}
                  </select>
                </div>
              </Col>
              <Col xs={12} sm={12} md={3} lg={3}>
                <div className="salescommonRecrd">
                  <i className="cui-note icons cmnRecordIcon" />
                  <span className="cmnPageCount">
                    {supportTicketsCount === undefined
                      ? 0
                      : <span>
                          {supportTicketsCount}
                        </span>}
                  </span>
                  <span className="cmnResutText">Results</span>
                </div>
              </Col>
            </Row>
          </div>
          {/* </Card.Header> */}
          <Card.Body className="tableCardBody">
            <div className="tablecommonCardBody">
              <Table hover responsive className="">
                <thead className="tablecommonCard">
                  <tr>
                    <th>#</th>
                    <th>Ticket No</th>
                    <th>Support</th>
                    <th>Support Type</th>
                    <th>Created Date</th>
                    <th>Status</th>
                    <th>Action</th>
                  </tr>
                </thead>
                {supportTickets !== undefined &&
                  supportTicketsCount !== 0 &&
                  supportTickets.map((item, i) =>
                    <tbody key={i} className="tableBody">
                      <tr>
                        <td>
                          {10 * (p - 1) + i + 1}
                        </td>
                        <td className="cmn_Cap">
                          {item && item.ticketNo}
                        </td>
                        <td className="cmn_Cap supportdesc">
                          {item && item.issueDesc
                            ? item.issueDesc.length > 10
                              ? `${item.issueDesc.substring(0, 30)} ...`
                              : item.issueDesc
                            : null}
                        </td>
                        <td className="cmn_Cap">
                          {item && item.sprtType && item.sprtType.disc}
                        </td>
                        <td>
                          {item && dateFormat(item.createdAt, 'dd-mmm-yyyy')}
                        </td>
                        <td className="cmn_Cap">
                          {item !== null && item.status === 'created'
                            ? <span className="badge badge-primary">
                                {' '}{item !== null && item.status
                                  ? item.status
                                  : null}
                              </span>
                            : item !== null && item.status === 'closed'
                              ? <span
                                  className="badge badge-success "
                                  style={{
                                    paddingLeft: '13px',
                                    paddingRight: '13px',
                                  }}
                                >
                                  {' '}{item !== null && item.status
                                    ? item.status
                                    : null}
                                </span>
                              : <span
                                  className="badge badge-warning"
                                  style={{color: 'white'}}
                                >
                                  {' '}{item !== null && item.status
                                    ? item.status
                                    : null}
                                </span>}
                        </td>

                        <td className="cmnViewIcon">
                          <OverlayTrigger
                            placement="bottom"
                            delay={{show: 250, hide: 400}}
                            overlay={this.renderTooltip}
                          >
                            <i
                              className="fa fa-eye fa-lg "
                              onClick={() => showsupportModal({item: item})}
                            />
                          </OverlayTrigger>

                          {/* <i
                            className="fa fa-eye fa-lg "
                            onClick={() => showsupportModal({ item: item })}
                          ></i> */}
                        </td>
                      </tr>
                    </tbody>
                  )}
              </Table>
              <SupportView
                show={showsupportviewModal}
                close={closesupportviewModal}
                supportDetail={this.state.supportDetail}
              />
              {SptPageCount > 1
                ? <div className="paginationDiv">
                    <ReactPaginate
                      forcePage={page}
                      previousLabel={'Prev'}
                      nextLabel={'Next'}
                      breakLabel={'...'}
                      breakClassName={'break-me'}
                      pageCount={SptPageCount}
                      marginPagesDisplayed={2}
                      pageRangeDisplayed={5}
                      onPageChange={handleSptPageClick}
                      containerClassName={'pagination flex-wrap'}
                      subContainerClassName={'pages pagination'}
                      activeClassName={'active'}
                    />
                  </div>
                : null}
              {(supportTickets === undefined ||
                (supportTickets && supportTicketsCount === 0)) &&
                <div>
                  <div className="noDataImgDiv">
                    <Image
                      className="noDataImg"
                      src={require('../../assets/img/nodata4.png')}
                    />
                  </div>
                  <div className="noDataTextDiv">No Support tickets found</div>
                </div>}
            </div>
          </Card.Body>
        </Card>
      </div>
    );
  }
}

export default Support;
